import React, { useEffect, useRef, useState } from "react";
import { useStores } from "../../store";
import { IoCloseCircleOutline } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import { useObserver } from "mobx-react";
export default function DeletePopup() {
  const { UserStore } = useStores();
  const navigate = useNavigate();
  const [mail, setMail] = useState();
  const [password, setPassword] = useState(null);
  const [googleAuth, setGoogleAuth] = useState(false);
  const [gettingPassword, setGettingPassword] = useState(false);
  const inputFieldPassword = useRef();
  const [response, setResponse] = useState("");
  const [loader, setLoader] = useState(false);
  // get local storage user_google
  useEffect(() => {
    let localStore = localStorage.getItem("user_google");
    let localStore2 = localStorage.getItem("user");

    if (localStore) {
      setMail(JSON.parse(localStore).email);
      setGoogleAuth(true);
    } else if (localStore2) {
      setMail(JSON.parse(localStore2).mail);
      setGoogleAuth(false);
    }
  }, []);
  const postUserDelete = async () => {
    setLoader("Please Wait.....");
    const result = await UserStore.DeleteUser(
      mail,
      inputFieldPassword.current.value
    );
    if (result === "Password is Incorrect") {
      setResponse("Password is Incorrect");
      setLoader("");
      return;
    }
    if (result === "User Deleted Successfully") {
      setLoader("");
      setResponse("User Deleted Successfully");
      setTimeout(() => {
        localStorage.removeItem("user_google");
        localStorage.clear();
        localStorage.removeItem("user");
        navigate("/login");
      }, 2000);
    }
    setLoader(false);
    setResponse(result);
    //  console.log(toJS(result), "the account is deleted..................")
    setLoader("");
  };
  return useObserver(() => (
    <>
      <div
        onClick={() => UserStore.setDeletePopup(false)}
        className="fixed inset-0 z-50 w-screen h-screen bg-black backdrop-filter backdrop-blur-sm bg-opacity-40"
      >
        <div
          onClick={(e) => e.stopPropagation()}
          className="absolute px-3 inset-0 bg-bg3 z-50 flex flex-col justify-center rounded-3xl border py-10 items-center md:w-[35%] lg:w-[30%] w-[90%] h-fit md:h-fit lg:h-fit m-auto shadow-lg overflow-y-auto no-scrollbar"
        >
          <IoCloseCircleOutline
            className="text-primary absolute text-xl cursor-pointer  top-2 right-2"
            onClick={() => UserStore.setDeletePopup(false)}
          />
          {!gettingPassword ? (
            <div className="flex flex-col justify-between h-full w-full py-10">
              <h1 className="md:text-xl lg:text-2xl  text-base text-center w-full font-medium ">
                Do you really want to Delete your account?!!
              </h1>
              <div className="flex  gap-20 md:gap-52 lg:gap-52 mt-10 justify-center items-center px-5">
                <button
                  onClick={() => UserStore.setDeletePopup(false)}
                  className="text-white max-w-[50%] bg-primary px-5 py-1 text-lg font-semibold rounded-lg"
                >
                  Cancel
                </button>
                <button
                  className="max-w-[50%] px-5 py-1 text-base rounded-md"
                  onClick={() => {
                    if (googleAuth) {
                      console.log(mail, "google Account");
                      navigate("/delete-account");
                    } else {
                      console.log(mail, "email Account");
                      setGettingPassword(true);
                    }
                  }}
                >
                  Delete
                </button>
              </div>
            </div>
          ) : (
            <>
              {response !== "User deleted successfully" ? (
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    postUserDelete(mail);
                  }}
                  className="flex flex-col gap-5 w-full justify-center py-10 items-center"
                >
                  <div>
                    <p className="text-sm text-gray-500">Enter Password</p>
                    <input
                      type="password"
                      autoComplete="false"
                      ref={inputFieldPassword}
                      name=""
                      className="border-[1px] px-2 h-8 rounded-sm outline-none"
                      id=""
                    />
                    <p className="text-sm text-red-400">{response}</p>
                  </div>
                  {!loader ? (
                    <button
                      onClick={() => {
                        // console.log(mail, inputFieldPassword.current.value)
                        postUserDelete(mail);
                      }}
                      className="text-white bg-primary px-3 font-semibold py-1 rounded-md"
                    >
                      Delete Account
                    </button>
                  ) : (
                    <p>{loader}</p>
                  )}
                </form>
              ) : (
                <CountdownTimer />
              )}
            </>
          )}
        </div>
      </div>
    </>
  ));
}

const CountdownTimer = () => {
  const [seconds, setSeconds] = useState(10);

  useEffect(() => {
    if (seconds > 0) {
      const intervalId = setInterval(() => {
        setSeconds((prevSeconds) => prevSeconds - 1);
      }, 1000);
      return () => clearInterval(intervalId);
    } else {
      // Perform actions when the timer reaches 0
      localStorage.removeItem("user");
      localStorage.removeItem("user_google");
      localStorage.clear();
      window.location.href = "/";
    }
  }, [seconds]);

  const formatTime = (secs) => {
    const hours = Math.floor(secs / 3600)
      .toString()
      .padStart(2, "0");
    const minutes = Math.floor((secs % 3600) / 60)
      .toString()
      .padStart(2, "0");
    const seconds = (secs % 60).toString().padStart(2, "0");
    return `${hours}:${minutes}:${seconds}`;
  };

  return (
    <div>
      <h1 className="text-xl font-bold mb-2 text-center">
        Wait for the Account to delete
      </h1>
      <div className="flex items-center justify-center bg-gray-200 rounded-lg p-4 mt-8">
        <span id="timer" className="text-2xl font-bold">
          {formatTime(seconds)}
        </span>
      </div>
    </div>
  );
};
